// Countries offered in the footer's Country/Region selector — our clientele first
export const countries = [
  { iso: 'AE', name: 'United Arab Emirates' },
  { iso: 'SA', name: 'Saudi Arabia' },
  { iso: 'QA', name: 'Qatar' },
  { iso: 'KW', name: 'Kuwait' },
  { iso: 'BH', name: 'Bahrain' },
  { iso: 'OM', name: 'Oman' },
  { iso: 'GB', name: 'United Kingdom' },
  { iso: 'CH', name: 'Switzerland' },
  { iso: 'MC', name: 'Monaco' },
  { iso: 'FR', name: 'France' },
  { iso: 'DE', name: 'Germany' },
  { iso: 'IT', name: 'Italy' },
  { iso: 'ES', name: 'Spain' },
  { iso: 'PL', name: 'Poland' },
  { iso: 'NL', name: 'Netherlands' },
  { iso: 'BE', name: 'Belgium' },
  { iso: 'AT', name: 'Austria' },
  { iso: 'LU', name: 'Luxembourg' },
  { iso: 'PT', name: 'Portugal' },
  { iso: 'GR', name: 'Greece' },
  { iso: 'TR', name: 'Türkiye' },
  { iso: 'RU', name: 'Russia' },
  { iso: 'US', name: 'United States' },
  { iso: 'CA', name: 'Canada' },
  { iso: 'SG', name: 'Singapore' },
  { iso: 'HK', name: 'Hong Kong' },
  { iso: 'CN', name: 'China' },
  { iso: 'JP', name: 'Japan' },
  { iso: 'IN', name: 'India' },
  { iso: 'AU', name: 'Australia' },
];

export const timezoneCountries: Record<string, string> = {
  'Asia/Dubai': 'AE',
  'Asia/Riyadh': 'SA',
  'Asia/Qatar': 'QA',
  'Asia/Kuwait': 'KW',
  'Asia/Bahrain': 'BH',
  'Asia/Muscat': 'OM',
  'Europe/London': 'GB',
  'Europe/Zurich': 'CH',
  'Europe/Monaco': 'MC',
  'Europe/Paris': 'FR',
  'Europe/Berlin': 'DE',
  'Europe/Rome': 'IT',
  'Europe/Madrid': 'ES',
  'Atlantic/Canary': 'ES',
  'Europe/Warsaw': 'PL',
  'Europe/Amsterdam': 'NL',
  'Europe/Brussels': 'BE',
  'Europe/Vienna': 'AT',
  'Europe/Luxembourg': 'LU',
  'Europe/Lisbon': 'PT',
  'Europe/Athens': 'GR',
  'Europe/Istanbul': 'TR',
  'Europe/Moscow': 'RU',
  'America/New_York': 'US',
  'America/Chicago': 'US',
  'America/Denver': 'US',
  'America/Los_Angeles': 'US',
  'America/Toronto': 'CA',
  'America/Vancouver': 'CA',
  'Asia/Singapore': 'SG',
  'Asia/Hong_Kong': 'HK',
  'Asia/Shanghai': 'CN',
  'Asia/Tokyo': 'JP',
  'Asia/Kolkata': 'IN',
  'Australia/Sydney': 'AU',
};

export const fallbackCountry = 'AE';
export const countryStorageKey = 'sl-country';
